var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-6 col-12 p-0 p-sm-2" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("h4", [
          _vm._v(_vm._s(_vm.$t("message.personal_data_management.title")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pb-2 text-small" }, [
          _c("div", { staticClass: "pt-2" }, [
            _vm._v(_vm._s(_vm.$t("message.personal_data_management.detail01")))
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "pt-3",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("message.personal_data_management.detail02")
              )
            }
          }),
          _vm._v(" "),
          _vm.personalTopics
            ? _c("div", { staticClass: "pt-3" }, [
                _c(
                  "ul",
                  {
                    staticClass: "list-unstyled",
                    staticStyle: { "line-height": "1.5rem" }
                  },
                  [
                    _vm._l(_vm.personalTopics, function(personalTopic, index) {
                      return [
                        _c("li", [
                          _vm._v(
                            _vm._s(index + 1) +
                              ". " +
                              _vm._s(
                                _vm.$i18n.locale === "th"
                                  ? personalTopic.title_th
                                  : personalTopic.title_en
                              )
                          )
                        ])
                      ]
                    })
                  ],
                  2
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-6 col-12 p-0 p-sm-2" }, [
        _vm.personalTopics && _vm.userPersonalTopics
          ? _c(
              "section",
              _vm._l(_vm.personalTopics, function(personalTopic, index) {
                return _c("div", { key: index, staticClass: "card mt-0" }, [
                  _c("img", {
                    staticClass: "card-img-top",
                    attrs: {
                      src: personalTopic.image_url,
                      alt: personalTopic.title_th
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body" }, [
                    _c("h4", [
                      _vm._v(
                        _vm._s(
                          _vm.$i18n.locale === "th"
                            ? personalTopic.title_th
                            : personalTopic.title_en
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-small" }, [
                      _vm.isShortText[index]
                        ? _c("span", {
                            directives: [
                              { name: "linkified", rawName: "v-linkified" }
                            ],
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.shortText(
                                  _vm.$i18n.locale === "th"
                                    ? personalTopic.content_th
                                    : personalTopic.content_en,
                                  80
                                )
                              )
                            }
                          })
                        : _c("span", {
                            directives: [
                              { name: "linkified", rawName: "v-linkified" }
                            ],
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$i18n.locale === "th"
                                  ? personalTopic.content_th
                                  : personalTopic.content_en
                              )
                            }
                          }),
                      _vm._v(" "),
                      _vm.isShortText[index]
                        ? _c(
                            "label",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.setIsShortText(index, false)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.personal_data_management.read_more"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _c("div", { staticClass: "form-check" }, [
                          _c("label", { staticClass: "form-check-label" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.userPersonalTopics[index].status,
                                  expression: "userPersonalTopics[index].status"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "personalTopic" + personalTopic.id
                              },
                              domProps: {
                                value: 1,
                                checked: _vm._q(
                                  _vm.userPersonalTopics[index].status,
                                  1
                                )
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(
                                      _vm.userPersonalTopics[index],
                                      "status",
                                      1
                                    )
                                  },
                                  function($event) {
                                    return _vm.setStatus(index, 1)
                                  }
                                ]
                              }
                            }),
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t(
                                    "message.personal_data_management.accept"
                                  )
                                ) +
                                "\n                  "
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6" }, [
                        _c("div", { staticClass: "form-check" }, [
                          _c("label", { staticClass: "form-check-label" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.userPersonalTopics[index].status,
                                  expression: "userPersonalTopics[index].status"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "personalTopic" + personalTopic.id
                              },
                              domProps: {
                                value: 0,
                                checked: _vm._q(
                                  _vm.userPersonalTopics[index].status,
                                  0
                                )
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(
                                      _vm.userPersonalTopics[index],
                                      "status",
                                      0
                                    )
                                  },
                                  function($event) {
                                    return _vm.setStatus(index, 0)
                                  }
                                ]
                              }
                            }),
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t(
                                    "message.personal_data_management.decline"
                                  )
                                ) +
                                "\n                  "
                            )
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.userPersonalTopics[index].status === 0 &&
                    personalTopic.can_decline === 0
                      ? _c(
                          "div",
                          { staticClass: "-status-alert text-small pt-2" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "message.personal_data_management.alert_message"
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              }),
              0
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-2" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-block btn-lg",
          class: _vm.canSubmit ? "btn-info" : "btn-secondary",
          attrs: { disabled: !_vm.canSubmit },
          on: {
            click: function($event) {
              return _vm.saveUserPersonalTopics()
            }
          }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.isLoading
                  ? _vm.$t("message.button.loading")
                  : _vm.$t("message.button.submit")
              ) +
              "\n    "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-4" }, [
      _c("img", {
        staticClass: "img-fluid rounded",
        attrs: { src: "https://beneat.co/images/pdpa00.jpg", alt: "" }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e495d46", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e495d46","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/privacy/ConfirmPersonalTopic.vue
// module id = 1470
// module chunks = 0